import { render, staticRenderFns } from "./JoinedInputWrapper.vue?vue&type=template&id=6fa9f55a&scoped=true&"
import script from "./JoinedInputWrapper.vue?vue&type=script&lang=js&"
export * from "./JoinedInputWrapper.vue?vue&type=script&lang=js&"
import style0 from "./JoinedInputWrapper.vue?vue&type=style&index=0&id=6fa9f55a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa9f55a",
  null
  
)

export default component.exports